// Customizable Area Start
import React, { Component } from "react";
import { Box, styled, Typography } from "@mui/material";
const ReadIcon = require("./read.svg").default;

const MainWrapper = styled(Box)({
  display: "flex",
  maxWidth: "70%",
  "&:has(.own_message)": {
    justifyContent: "flex-end",
  },
  "@media (max-width: 850px)": {
    maxWidth: "85%",
  },
  "@media (max-width: 414px)": {
    maxWidth: "90%",
  },
});

const MessageBubble = styled(Box)({
  padding: "10px 10px 8px",
  borderRadius: "0px 12px 12px 12px ",
  backgroundColor: "#F1F5F9",
  position: "relative",
  display: "flex",
  gap: "8px",
  "&::before": {
    content: "''",
    position: "absolute",
    left: "-10px",
    top: "0",
    width: "0",
    height: "0",
    border: "10px solid transparent",
    borderRightColor: "#F1F5F9",
    borderTopColor: "#F1F5F9",
  },
  "&.own_message": {
    borderRadius: "12px 0px 12px 12px",
    "&::before": {
      left: "unset",
      right: "-10px",
      borderLeftColor: "#F1F5F9",
      borderRightColor: "transparent",
    },
  },
});

const MessageText = styled(Typography)({
  fontWeight: 400,
  fontSize: "0.875rem",
  color: "#0F172A",
  flex: 1,
  paddingBottom: "12px",
  wordBreak: "break-word",
  "@media (max-width: 414px)": {
    fontSize: "0.80rem",
  },
});

const MessageInfoWrapper = styled(Box)({
  display: "flex",
  alignItems: "flex-end",
  gap: "3px",
});

const MessageTime = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "isOwnMessage",
})<{ isOwnMessage?: boolean }>(({ isOwnMessage }) => ({
  fontWeight: isOwnMessage ? 400 : 500,
  fontSize: "0.75rem",
  color: isOwnMessage ? "#64748B" : "#666668",
  justifyContent: "flex-end",
  lineHeight: 0.7,
  "@media (max-width: 414px)": {
    fontSize: "0.7rem",
  },
}));

interface Props {
  id: string;
  date: string;
  time: string;
  message: string;
  senderId: string;
  chatId: string;
  isSeen: boolean;
  loggedInUserId: string;
}

class CustomChatBubble extends Component<Props> {
  render() {
    const { date, time, message, loggedInUserId, senderId, isSeen } = this.props;
    const isOwnMessage = loggedInUserId === senderId;

    return (
      <MainWrapper>
        <MessageBubble className={isOwnMessage ? "own_message" : ""} title={`${date} ${time}`}>
          <MessageText>{message}</MessageText>
          <MessageInfoWrapper>
            <MessageTime isOwnMessage={isOwnMessage}>{time}</MessageTime>
            {isOwnMessage && isSeen && <img src={ReadIcon} alt="Seen" />}
          </MessageInfoWrapper>
        </MessageBubble>
      </MainWrapper>
    );
  }
}

export default CustomChatBubble;
// Customizable Area End
